import React from 'react';
import { TextField, MenuItem } from '@mui/material';

export const SelectBlock = ({ setting, onValueChange, controlSize = 'small', fullWidth = false }) => {
    const handleChange = (event) => {
        onValueChange(setting.id, event.target.value);
    };

    return (
        <TextField
            select
            disabled={!setting.is_active}
            value={setting.parameter_value || ""}
            onChange={handleChange}
            variant="outlined"
            size={controlSize}
            fullWidth={fullWidth}
        >
            {setting.options?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
};
